import { render, staticRenderFns } from "./DndInvoices.vue?vue&type=template&id=517ad1ab&scoped=true"
import script from "./DndInvoices.vue?vue&type=script&lang=js"
export * from "./DndInvoices.vue?vue&type=script&lang=js"
import style0 from "./DndInvoices.vue?vue&type=style&index=0&id=517ad1ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517ad1ab",
  null
  
)

export default component.exports